import HubertTooltip from 'components/HubertUI/HubertTooltip';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  disabled?: boolean;
  message?: ReactNode;
}

const UneditableInfoTooltip = ({
  children,
  disabled,
  // TODO(i18n): Category 4 — default message has <span className="italic"> mid-sentence; needs Trans component or full-sentence restructuring
  message = (
    <div className="w-64 whitespace-normal">
      Not editable for this specific template. To update this text, click <span className="italic">Go to question</span>{' '}
      above or create a new copy of the question
    </div>
  ),
}: Props) => {
  if (!disabled) {
    return <>{children}</>;
  }

  return (
    <HubertTooltip>
      <HubertTooltip.Trigger asChild>
        <div className="w-full cursor-not-allowed">{children}</div>
      </HubertTooltip.Trigger>
      <HubertTooltip.Content portalContent={true}>{message}</HubertTooltip.Content>
    </HubertTooltip>
  );
};

export default UneditableInfoTooltip;
